import { useRef, createContext, useContext } from "react";

const SearchContext = createContext();
const SearchProvider = ({ children }) => {
  const mapSearchRef = useRef(null);
  const getMapSearchRef = () => mapSearchRef.current;
  const contextValue = {
    mapSearchRef,
    getMapSearchRef,
  };
  return (
    <SearchContext.Provider value={contextValue}>
      {children}
    </SearchContext.Provider>
  );
};

const useSearch = () => {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error("useSearch must be used within a <SearchProvider/>");
  }
  return context;
};

export { SearchProvider as default, useSearch };
